import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    question: '¿Necesito saber algo de budismo para leerlo?',
    answer: 'En absoluto. El libro está escrito específicamente para principiantes y personas ocupadas. No usamos jerga religiosa ni conceptos místicos complicados, solo principios prácticos.'
  }, {
    question: '¿En qué formato recibiré el libro?',
    answer: 'Inmediatamente después de la compra, recibirás un enlace para descargar el libro en formato PDF (ideal para leer en computadora o tablet) y ePub (perfecto para Kindle y otros e-readers).'
  }, {
    question: '¿Cuánto tiempo me tomarán los ejercicios diarios?',
    answer: 'Los ejercicios están diseñados para adaptarse a una vida moderna ocupada. La mayoría toman entre 5 y 10 minutos al día. La constancia es más importante que la duración.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-[#0A192F]" data-id="element-21">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-22">
        <div className="text-center mb-16" data-id="element-23">
          <h2 className="text-4xl font-['Playfair_Display'] text-[#FFF8F0]" data-id="element-24">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-25">
          {faqs.map((faq, index) => <div key={index} className="border border-[#1D3461] rounded-xl bg-[#112240]/50 overflow-hidden" data-id="element-26">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-27">
                <span className="text-[#FFF8F0] font-['Inter'] font-medium text-lg pr-4" data-id="element-28">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-[#D4AF37] transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-29" />
              </button>

              <AnimatePresence data-id="element-30">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-31">
                    <div className="px-6 pb-5 text-[#A8B2D1] font-['Inter'] leading-relaxed" data-id="element-32">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}